import React from 'react';

import cs from 'classnames';
import {Link} from 'react-router';

import {useCurrentUserState} from 'app/current-user/api';
import {useAccountSettingsState} from 'app/settings/api';
import {
  ACCOUNT_2FA,
  ACCOUNT_CREATE_URL,
  ACCOUNT_EMAIL_URL,
  ACCOUNT_EXPORT_PDF,
  ACCOUNT_MIGRATION_URL,
  ACCOUNT_OVERVIEW_URL,
  ACCOUNT_PASSWORD_CHANGE_URL,
  ACCOUNT_REFERRALS_URL,
  ACCOUNT_REPORT_URL,
  ACCOUNT_SCIM_URL,
  ACCOUNT_TOKENS_URL,
  ACCOUNT_WEBHOOK_URL,
  BILLING_DETAIL_URL,
  BILLING_NEW_URL,
  BILLING_REPORT_URL,
  RECYCLE_BIN_URL,
} from 'app/urls';
import {gt} from 'app/utils/i18n';

export interface Props {
  location: 'index' | 'reports' | 'stripe' | 'scim' | 'referrer' | 'recycle';
}

export function AccountOverviewSidebar({location}: Props): JSX.Element {
  const {is_owner, is_billing_admin, is_super_manager} =
    useCurrentUserState().data!;

  const {is_new_account, is_peruser, is_paying, is_saml} =
    useAccountSettingsState().data!;

  return (
    <nav className="col-md-3 col-xl-2 bg-light pt-4">
      <div className="sidebar-sticky">
        <ul className="nav flex-column nav-pills">
          <li className="nav-item">
            <Link
              className={cs('nav-link', {active: location === 'index'})}
              to={ACCOUNT_OVERVIEW_URL}
            >
              {gt('Account Overview')}
            </Link>
          </li>
          <li className="nav-item ">
            <a className="nav-link " href={ACCOUNT_EMAIL_URL}>
              {gt('Notification Settings')}
            </a>
          </li>
          <li className="nav-item ">
            <a className="nav-link " href={ACCOUNT_2FA}>
              {gt('Security')}
            </a>
          </li>
          <li className="nav-item ">
            <a className="nav-link " href={ACCOUNT_PASSWORD_CHANGE_URL}>
              {gt('Change Password')}
            </a>
          </li>
          <li className="nav-item ">
            <a className="nav-link " href={ACCOUNT_TOKENS_URL}>
              {gt('API')}
            </a>
          </li>
          {is_super_manager ? (
            <li className="nav-item">
              <Link
                className={`nav-link ${location === 'scim' ? 'active' : ''}`}
                to={ACCOUNT_SCIM_URL}
              >
                {gt('SCIM')}
              </Link>
            </li>
          ) : null}

          <li className="nav-item ">
            <a className="nav-link " href={ACCOUNT_WEBHOOK_URL}>
              {gt('Webhooks')}
            </a>
          </li>

          {is_owner || is_billing_admin ? (
            is_new_account ? (
              <li className="nav-item ">
                <a
                  className={`nav-link ${location == 'stripe' ? 'active' : ''}`}
                  href={BILLING_NEW_URL}
                >
                  {gt('My Subscription')}
                </a>
              </li>
            ) : (
              <>
                <li className="nav-item ">
                  <a
                    className={`nav-link ${
                      location == 'stripe' ? 'active' : ''
                    }`}
                    href={BILLING_DETAIL_URL}
                  >
                    {gt('Billing Overview')}
                  </a>
                </li>
                {is_peruser ? (
                  <li className="nav-item ">
                    <a className="nav-link " href={BILLING_REPORT_URL}>
                      {gt('Billing Report')}
                    </a>
                  </li>
                ) : null}
              </>
            )
          ) : null}

          {is_super_manager ? (
            <li className="nav-item">
              <Link
                className={cs('nav-link', {active: location == 'reports'})}
                to={ACCOUNT_REPORT_URL}
              >
                {gt('Reports')}
              </Link>
            </li>
          ) : null}

          {is_owner ? (
            <li className="nav-item ">
              <a className="nav-link " href={ACCOUNT_MIGRATION_URL}>
                {gt('Migration Service')}
              </a>
            </li>
          ) : null}

          {is_super_manager ? (
            <>
              <li className="nav-item ">
                <Link
                  className={cs('nav-link', {active: location == 'recycle'})}
                  to={RECYCLE_BIN_URL}
                >
                  {gt('Recycle Bin')}
                </Link>
              </li>
              <li className="nav-item ">
                <a className="nav-link " href={ACCOUNT_EXPORT_PDF}>
                  {gt('Export')}
                </a>
              </li>
            </>
          ) : null}

          {is_owner ? (
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location === 'referrer' ? 'active' : ''
                }`}
                to={ACCOUNT_REFERRALS_URL}
              >
                {gt('Referrals')}
              </Link>
            </li>
          ) : null}

          {is_paying && !is_saml ? (
            <li className="nav-item">
              <a className="nav-link" href={ACCOUNT_CREATE_URL}>
                {gt('Create New Account')}
              </a>
            </li>
          ) : null}
        </ul>
      </div>
    </nav>
  );
}
